export default "__VITE_ASSET__58b9bd18__"